import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { Coupon } from '@cds/betting-offer/domain-specific/coupons';
import { MultiBuilderConfig } from '@frontend/sports/common/client-config-data-access';
import { RedirectHelperService } from '@frontend/sports/navigation/core/feature/redirect';
import { UrlHelperService } from '@frontend/sports/navigation/core/feature/url-helper';
import { sortBy } from 'lodash-es';
import { Observable, map, of, switchMap } from 'rxjs';

import { MultiBuilderTrackingService } from './multi-builder-tracking.service';
import { MultiBuilderCoupon } from './multi-builder.model';
import { MultiBuilderService } from './multi-builder.service';

@Injectable()
export class MultiBuilderGuard {
    constructor(
        private redirectHelperService: RedirectHelperService,
        private multiBuilderConfig: MultiBuilderConfig,
        private multiBuilderService: MultiBuilderService,
        private urlhelper: UrlHelperService,
        private trackingService: MultiBuilderTrackingService,
    ) {}

    canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
        return this.multiBuilderConfig.whenReady.pipe(
            switchMap(() => {
                if (!this.multiBuilderConfig.isEnabled) {
                    this.redirectHelperService.goHome();

                    return of(false);
                }

                return this.multiBuilderService.getMultibuilderCoupons().pipe(
                    map((coupons) => {
                        let redirect = false;
                        const orderedCoupons = this.getOrderedCoupons(coupons);
                        if (orderedCoupons.length) {
                            let activeCoupon = orderedCoupons.find((coupon) => coupon.id === Number(route.params.coupon));
                            this.trackingService.restrictCompetitionSwitchTrack = false;

                            if (!activeCoupon) {
                                redirect = true;
                                activeCoupon = orderedCoupons[0];
                                this.trackingService.restrictCompetitionSwitchTrack = true;
                            }
                            if (activeCoupon === orderedCoupons[0]) {
                                this.trackingService.restrictCompetitionSwitchTrack = true;
                            }
                            const defaultUrl = this.urlhelper.getMultiBuilderUrl({
                                id: activeCoupon.id,
                                name: activeCoupon.name,
                            });
                            if (redirect) {
                                this.redirectHelperService.goToPage(defaultUrl, true);
                            }

                            return true;
                        }

                        return false;
                    }),
                );
            }),
        );
    }

    private getOrderedCoupons(model: Coupon[] | undefined): MultiBuilderCoupon[] {
        if (!model) {
            return [];
        }

        return sortBy(model, (coupon) => coupon.order);
    }
}
